<app-organizer-shared-layout-dashboard
  [hasFooter]="true"
  class="organizer-timeslot-page-schedule"
>
  <div class="col-span-12 md:col-span-5 md:col-start-2">
    <app-section
      [description]="
        'activity_planning.schedule.layout.description' | translate
      "
      [title]="'activity_planning.schedule.layout.title' | translate"
    >
      <a
        class="self-start mb-6"
        app-vtmn-play-button
        [routerLink]="'/organizer.activity-creation.welcome' | localize"
      >
        {{ 'activity_planning.schedule.button.create_activity' | translate }}
      </a>

      <app-router-tab-bar [tabBarLinks]="tabBarlinks">
        <router-outlet></router-outlet>
      </app-router-tab-bar>
    </app-section>
  </div>
</app-organizer-shared-layout-dashboard>
